import {ExternalLink, TextSmallRegular} from '@hm/fundamental'
import moment from 'moment/moment'

import {Invoice} from '../Invoice.types'

const EINVOICE_DEMO_URL = 'https://qr-demo.ksef.mf.gov.pl/client-app/invoice/'
const EINVOICE_PROD_URL = 'https://qr.ksef.mf.gov.pl/client-app/invoice/'

type KSeFInvoiceProps = {
  invoice: Invoice
  className?: string
}
export const KSeFInvoice = ({invoice, className}: KSeFInvoiceProps) => {
  const isProd = process.env.REACT_APP_STAGE === 'prod'

  const formatDateToKSeFFormat = (dateString: string): string => {
    return moment(dateString).format('DD-MM-YYYY')
  }

  const convertToBase64Url = (base64: string): string => {
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
  }

  const handleKsefUrl = () => {
    if (
      invoice.electronicInvoiceNr &&
      invoice.electronicInvoiceSecureHash &&
      invoice.electronicInvoiceDate
    ) {
      const eInvoiceNr = encodeURIComponent(invoice.electronicInvoiceNr.trim().split('-')[0])
      const eInvoiceHash = convertToBase64Url(invoice.electronicInvoiceSecureHash.trim())
      const eInvoiceDate = encodeURIComponent(
        formatDateToKSeFFormat(invoice.electronicInvoiceDate.trim())
      )

      return `${
        isProd ? EINVOICE_PROD_URL : EINVOICE_DEMO_URL
      }${eInvoiceNr}/${eInvoiceDate}/${eInvoiceHash}`
    }
  }

  return (
    <ExternalLink
      href={handleKsefUrl()}
      className={`${className} [&_span]:text-[14px] [&_span]:leading-[16px]`}
      data-cy={`ksef-invoice-link-${invoice.electronicInvoiceNr}`}
    >
      <TextSmallRegular>{invoice.electronicInvoiceNr}</TextSmallRegular>
    </ExternalLink>
  )
}
